export const PERIOD_OPTIONS = [
  { value: '7d', days: 7, labelKey: 'recruiterActivity.period7', fallback: 'Last 7 days' },
  { value: '30d', days: 30, labelKey: 'recruiterActivity.period30', fallback: 'Last 30 days' },
  { value: '90d', days: 90, labelKey: 'recruiterActivity.period90', fallback: 'Last 90 days' },
];

export const STATUS_CONFIG = {
  scheduled: {
    key: 'recruiterActivity.statusScheduled',
    fallback: 'Scheduled',
    className: 'bg-amber-100 text-amber-800',
    dot: 'bg-amber-400',
  },
  in_progress: {
    key: 'recruiterActivity.statusInProgress',
    fallback: 'In Progress',
    className: 'bg-sky-100 text-sky-800',
    dot: 'bg-sky-500',
  },
  completed: {
    key: 'recruiterActivity.statusCompleted',
    fallback: 'Completed',
    className: 'bg-emerald-100 text-emerald-800',
    dot: 'bg-emerald-500',
  },
  expired: {
    key: 'recruiterActivity.statusExpired',
    fallback: 'Expired',
    className: 'bg-rose-100 text-rose-800',
    dot: 'bg-rose-500',
  },
};

export const ratePercent = (rate) => {
  const numeric = Number(rate);
  if (!Number.isFinite(numeric) || numeric <= 0) return 0;
  return Math.min(100, Math.round(numeric * 100));
};

export const formatRate = (rate) => {
  const numeric = Number(rate);
  if (!Number.isFinite(numeric)) return '0%';
  return `${Math.round(numeric * 100)}%`;
};

export const formatCardDate = (iso) => {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const toDateParam = (iso) => {
  if (!iso) return '';
  return String(iso).slice(0, 10);
};

export const adminInitials = (name) => {
  const parts = String(name || '').trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
};

export const filterRecruiters = (recruiters, query, view) => {
  const needle = String(query || '').trim().toLowerCase();
  return (recruiters || []).filter((row) => {
    const scheduled = Number(row.scheduled || 0);
    if (view === 'idle' && scheduled !== 0) return false;
    if (view === 'active' && scheduled === 0) return false;
    if (!needle) return true;
    const haystack = String(row.name || '').toLowerCase();
    return haystack.includes(needle);
  });
};

export const sortRecruiters = (recruiters, sortKey, direction, idleFirst) => {
  const list = Array.isArray(recruiters) ? [...recruiters] : [];
  const dir = direction === 'asc' ? 1 : -1;
  list.sort((a, b) => {
    if (idleFirst) {
      const aIdle = a.scheduled === 0 ? 0 : 1;
      const bIdle = b.scheduled === 0 ? 0 : 1;
      if (aIdle !== bIdle) return aIdle - bIdle;
    }
    if (sortKey === 'name' || sortKey === 'role') {
      return String(a[sortKey] || '').localeCompare(String(b[sortKey] || '')) * dir;
    }
    const av = Number(a[sortKey] ?? 0);
    const bv = Number(b[sortKey] ?? 0);
    if (av !== bv) return (av - bv) * dir;
    return String(a.name || '').localeCompare(String(b.name || ''));
  });
  return list;
};

export const summaryCsv = (recruiters) => {
  const headers = ['Name', 'Scheduled', 'Completed', 'In Progress', 'Pending', 'Expired', 'Completion Rate'];
  const rows = (recruiters || []).map((row) => [
    row.name || '',
    row.scheduled ?? 0,
    row.completed ?? 0,
    row.in_progress ?? 0,
    row.pending ?? 0,
    row.expired ?? 0,
    formatRate(row.completion_rate),
  ]);
  const escape = (value) => `"${String(value).replace(/"/g, '""')}"`;
  return `\uFEFF${[headers, ...rows].map((line) => line.map(escape).join(',')).join('\r\n')}`;
};
